import { Service } from '@estee/elc-service';
import {
    ORDER_TRACKING,
    ORDER_TRACKING_INFORMATION,
    ORDER_TRACKING_STATUS
} from '@estee/elc-service-view-names';
import { OrderTrackingServiceStartedUseCase } from '../internal/use-cases/OrderTrackingServiceStartedUseCase';
import { IAppConfig, ServiceInitializer } from '@estee/elc-universal-utils';
import { diContainer, serviceNames } from './diContainer';

const { name, version } = __serviceInfo__;

export class OrderTrackingService extends Service {
    constructor(serviceInitializer: ServiceInitializer) {
        super(name, version, serviceInitializer);
        this.registerView(
            ORDER_TRACKING,
            () =>
                import(
                    /* webpackChunkName: 'OrderTracking'*/
                    '../exported/OrderTracking'
                )
        );

        this.registerView(
            ORDER_TRACKING_INFORMATION,
            () =>
                import(
                    /* webpackChunkName: 'OrderTrackingInformation'*/
                    '../exported/OrderTrackingInformation'
                ),
            () => diContainer.get(serviceNames.orderTrackingInformationViewController)
        );

        this.registerView(
            ORDER_TRACKING_STATUS,
            () =>
                import(
                    /* webpackChunkName: 'OrderStatusInfo'*/
                    '../exported/order-status/OrderStatusInfo'
                ),
            () => diContainer.get(serviceNames.orderStatusViewController)
        );
    }

    public async start(config: IAppConfig) {
        await super.start(config);
        const orderTrackingServiceUseCase = new OrderTrackingServiceStartedUseCase();
        await orderTrackingServiceUseCase.execute();
    }
}
